import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import StorefrontCartsTable from '../../components/Storefront/Carts/StorefrontCartsTable';
import PreparedCartsTable from '../../components/Storefront/PreparedCart/PreparedCartsTable';

const StorefrontCartsPage: React.FC = () => {
    return (
        <div className='main-content'>
            <h1>Storefront Carts</h1>
            <Pivot>
                <PivotItem headerText='Customer Carts'>
                    <StorefrontCartsTable />
                </PivotItem>
                <PivotItem headerText='Prepared Carts'>
                    <PreparedCartsTable />
                </PivotItem>
            </Pivot>
        </div>
    );
};

export default StorefrontCartsPage;
